import React, { useMemo } from "react";
import EChart from "./EChart";

// Graf z bloku ```graf {...}``` v odpovědi chatbota: {typ: bar|line, titulek, jednotka, popisky, rady: [{nazev, hodnoty}]}
const COLORS = ["#13a870", "#0f172a", "#29d59c", "#94a3b8", "#d97706"];
const nf = new Intl.NumberFormat("cs-CZ", { maximumFractionDigits: 1 });

export default function ChatChart({ spec }) {
  const option = useMemo(() => {
    const labels = spec.popisky || [];
    const horizontal = spec.typ !== "line" && labels.length > 6;
    const unit = spec.jednotka ? ` ${spec.jednotka}` : "";
    const catAxis = {
      type: "category",
      data: horizontal ? [...labels].reverse() : labels,
      axisTick: { show: false },
      axisLine: { lineStyle: { color: "#e2e8f0" } },
      axisLabel: { color: "#64748b", width: horizontal ? 210 : 90, overflow: "truncate", interval: 0, rotate: !horizontal && labels.length > 5 ? 30 : 0 },
    };
    const valAxis = { type: "value", axisLabel: { color: "#64748b" }, splitLine: { lineStyle: { color: "#eef2f6" } } };
    const series = (spec.rady || []).map((r, i) => ({
      name: r.nazev,
      type: spec.typ === "line" ? "line" : "bar",
      data: horizontal ? [...(r.hodnoty || [])].reverse() : r.hodnoty || [],
      barMaxWidth: 22,
      smooth: false,
      symbolSize: 6,
      itemStyle: { color: COLORS[i % COLORS.length], borderRadius: horizontal ? [0, 4, 4, 0] : [4, 4, 0, 0] },
      lineStyle: { width: 2.5 },
      label: horizontal && (spec.rady || []).length === 1
        ? { show: true, position: "right", color: "#334155", fontSize: 11, formatter: (p) => nf.format(p.value) }
        : undefined,
    }));
    return {
      grid: { left: horizontal ? 220 : 44, right: horizontal ? 48 : 20, top: series.length > 1 ? 34 : 14, bottom: horizontal ? 20 : 44 },
      legend: series.length > 1 ? { top: 0, left: 0, textStyle: { color: "#475569" } } : undefined,
      tooltip: { trigger: "axis", valueFormatter: (v) => (v == null ? "—" : `${nf.format(v)}${unit}`) },
      xAxis: horizontal ? valAxis : catAxis,
      yAxis: horizontal ? catAxis : valAxis,
      series,
    };
  }, [spec]);
  const n = (spec.popisky || []).length;
  const height = spec.typ !== "line" && n > 6 ? Math.min(40 + n * 26, 520) : 260;
  return (
    <figure className="cb2-chart">
      {spec.titulek && <figcaption>{spec.titulek}</figcaption>}
      <EChart option={option} height={height} />
    </figure>
  );
}
